(() => {
  const root = document.querySelector('[data-article-page]');
  if (!root) return;

  const content = root.querySelector('[data-article-content]');
  const toc = root.querySelector('[data-article-toc]');
  const tocList = root.querySelector('[data-article-toc-list]');

  const slugify = (text) =>
    text
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .slice(0, 64);

  const buildToc = () => {
    if (!content || !toc || !tocList) return;

    const headings = [...content.querySelectorAll('h1, h2')].filter((el) => el.textContent.trim());
    if (!headings.length) return;

    const used = new Set();
    tocList.innerHTML = '';

    headings.forEach((heading) => {
      let id = heading.id || slugify(heading.textContent) || `section-${used.size + 1}`;
      let n = 2;
      while (used.has(id) || (document.getElementById(id) && document.getElementById(id) !== heading)) {
        id = `${slugify(heading.textContent) || 'section'}-${n}`;
        n += 1;
      }
      used.add(id);
      heading.id = id;

      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${id}`;
      link.className = 'article-page__toc-link';
      link.textContent = heading.textContent.trim();
      link.dataset.tocTarget = id;
      item.appendChild(link);
      tocList.appendChild(item);
    });

    toc.hidden = false;

    const links = [...tocList.querySelectorAll('[data-toc-target]')];
    const setActive = (id) => {
      links.forEach((link) => {
        link.classList.toggle('is-active', link.dataset.tocTarget === id);
      });
    };

    if (links[0]) setActive(links[0].dataset.tocTarget);

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio);
        if (visible[0]?.target?.id) setActive(visible[0].target.id);
      },
      {
        rootMargin: '-20% 0px -55% 0px',
        threshold: [0.1, 0.5, 1],
      }
    );

    headings.forEach((heading) => observer.observe(heading));
  };

  const bindCopy = () => {
    root.querySelectorAll('[data-share-copy]').forEach((button) => {
      let resetTimer;
      button.addEventListener('click', async () => {
        const url = button.getAttribute('data-share-url');
        if (!url) return;
        try {
          await navigator.clipboard.writeText(url);
          button.classList.add('is-copied');
          button.setAttribute('aria-label', 'Link copied');
          window.clearTimeout(resetTimer);
          resetTimer = window.setTimeout(() => {
            button.classList.remove('is-copied');
            button.setAttribute('aria-label', 'Copy link');
          }, 1800);
        } catch {
          window.prompt('Copy this link', url);
        }
      });
    });
  };

  buildToc();
  bindCopy();
})();
